import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['emailField'];

  change() {
    this.emailFieldTarget.value = this.emailFieldTarget.value.toLowerCase();
  }
}
